import React, { useContext } from "react";
import "./toggle.css";
import Sun from "../../img/sun.png";
import Moon from "../../img/moon.png";
import { ThemeContext } from "../../context";
import { trackThemeChange } from "../../utils/analytics";

const Toggle = () => {
  const theme = useContext(ThemeContext);

  const handleClick = () => {
    const nextMode = !theme.state.darkMode;
    trackThemeChange(nextMode);
    theme.dispatch({ type: "TOGGLE" });
  };

  return (
    <div className="t" onClick={handleClick}>
      <img src={Sun} alt="Light Mode" className="t-icon t-icon-left" />
      <img src={Moon} alt="Dark Mode" className="t-icon t-icon-right" />
      <div
        className="t-button"
        style={{
          transform: theme.state.darkMode
            ? "translateX(26px)"
            : "translateX(0)",
        }}
      ></div>
    </div>
  );
};

export default Toggle;
